import { useTable } from 'components/ControlledTable';
import { fetcher } from 'services';
import invariant from 'tiny-invariant';
import type { Notification } from './types';
import { useIndicatorInvalidate } from 'core/Indicators';

export function useListSeenToggle({ id, last_seen_at }: Notification): () => Promise<void> {
  const { mutate } = useTable();
  const invalidate = useIndicatorInvalidate();
  const handleToggle = async (): Promise<void> => {
    const isSeen = Boolean(last_seen_at);
    const endpoint = isSeen ? 'mark_unseen' : 'mark_seen';

    await mutate(
      async (data) => {
        invariant(data);
        const res = await fetcher<Notification>({
          method: 'POST',
          url: `notifications/notifications/${id}/${endpoint}/`,
        });
        return { ...data, rows: data.rows.map((r) => (r.id === id ? res : r)) };
      },
      { revalidate: true }, // jums from all / unseen lists
    );
    await invalidate('unseen_notifications');
  };

  return handleToggle;
}
